module.exports = __webpack_public_path__ + "img/bankitpay.a106ba20.png";